var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H2C1.44772 7 1 7.44772 1 8V15C1 15.5523 1.44772 16 2 16H22C22.5523 16 23 15.5523 23 15V8C23 7.44772 22.5523 7 22 7ZM2 6C0.895431 6 0 6.89543 0 8V15C0 16.1046 0.89543 17 2 17H22C23.1046 17 24 16.1046 24 15V8C24 6.89543 23.1046 6 22 6H2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.125 13H3V10H4.125V13ZM8.625 13H5.25V10H8.625V13ZM12 13H9.75V10H12V13ZM18.75 13H13.125V10H18.75V13ZM21 13H19.875V10H21V13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/button.0a79e316b2ad667cd1ae9d276c7d97c3.svg";
export { ForwardRef as ReactComponent };